module.exports = __webpack_public_path__ + "img/edu-banner-blog.946eb472.png";